import React, { PureComponent } from "react";

import "../css/Tictactoe/Score.css";

import { GameContext } from "../context/game-context";

class Score extends PureComponent {
  static contextType = GameContext;

  render() {
    const { score } = this.context;
    const { firstPlayer, secondPlayer } = score;
    const youAreCross = this.props.player !== "circle";

    return (
      <div className="scoreboard">
        <div className="score-side score-cross">
          <span className="score-name">Cross</span>
          <span className="score-value">
            <span>{firstPlayer}</span>
          </span>
          <span className="score-role">
            {youAreCross ? "(you)" : "(opponent)"}
          </span>
        </div>
        <span className="score-separator" aria-hidden="true">
          -
        </span>
        <div className="score-side score-circle">
          <span className="score-value">
            <span>{secondPlayer}</span>
          </span>
          <span className="score-name">Circle</span>
          <span className="score-role">
            {youAreCross ? "(opponent)" : "(you)"}
          </span>
        </div>
      </div>
    );
  }
}

export default Score;
